{
  "validation.required": "{{label}}은(는) 필수 필드입니다.",
  "validation.minLength": "{{label}}은 {{min}}자 이상이어야 합니다.",
  "validation.maxLength": "{{label}}은 {{max}}자를 초과할 수 없습니다.",
  "validation.contentTypeAlphanumeric": "{{label}}은 영숫자여야 합니다.",
  "validation.contentTypeDate": "{{label}}은 날짜여야 합니다.",
  "validation.contentTypeDateBefore": "{{label}}은 {{date beforeDate}} 이전 날짜여야 합니다.",
  "validation.contentTypeDateAfter": "{{label}}은(는) {{date afterDate}} 이후의 날짜여야 합니다.",
  "validation.contentTypeDatetime": "{{label}}은 날짜와 시간이어야 합니다.",
  "validation.contentTypeDatetimeBefore": "{{label}}은 {{datetime beforeDate}} 이전 날짜여야 합니다.",
  "validation.contentTypeDatetimeAfter": "{{label}}은 {{datetime afterDate}} 이후의 날짜여야 합니다.",
  "validation.contentTypeEmail": "{{label}}은(는) 이메일이어야 합니다.",
  "validation.contentTypeInteger": "{{label}}은 숫자여야 합니다.",
  "validation.contentTypeNumber": "{{label}}은(는) 숫자여야 합니다.",
  "validation.contentTypeRegex": "{{label}} 형식이 잘못되었습니다.",
  "validation.contentTypeText": "{{label}}은 텍스트여야 합니다.",
  "validation.contentTypeTime": "{{label}}은 시간이어야 합니다.",
  "validation.contentTypeUrl": "{{label}}은 웹 주소여야 합니다.",
  "select-element.default-option": "고르다…",
  "button-element.network-required": "현재 오프라인 상태입니다. 계속하려면 네트워크 연결을 설정하세요."
}